/**
 * Community Showcase visibility gate.
 *
 * While the feature is in private preview, the ENTIRE Showcase is admin-only:
 * viewing (gallery, detail pages, home-page carousel, nav entries) AND every
 * mutation (publishing, the Share buttons, likes, "my showcase"). Non-admins
 * see and touch nothing.
 *
 * To open the Showcase to everyone, flip SHOWCASE_PUBLIC to true — that single
 * change re-enables the public routes, the carousel, the nav links, the Share
 * buttons, and subscriber-gated publishing.
 */
export const SHOWCASE_PUBLIC = true;

/** Who can browse/interact with the Showcase: admins always; everyone once public. */
export function canViewShowcase(isAdmin: boolean): boolean {
  return SHOWCASE_PUBLIC || isAdmin;
}

/**
 * Who can publish. Admins always (so they can seed during the preview); once
 * public, publishing opens to paying subscribers. During the private preview
 * this is admin-only — non-admin subscribers can't publish yet.
 */
export function canPublishToShowcase(isAdmin: boolean, isSubscriber: boolean): boolean {
  return isAdmin || (SHOWCASE_PUBLIC && isSubscriber);
}
